/* Draft pilot: existing Shopify option IDs remain the only purchase values. */
if (!customElements.get('mamam-coffee-form')) {
  customElements.define('mamam-coffee-form', class extends HTMLElement {
    connectedCallback() {
      this.host = this.closest('product-info');
      if (!this.host) return;
      this.wholeId = this.dataset.wholeId;
      this.mode = 'whole';
      this.method = '';
      this.pending = false;
      this.select = this.querySelector('[data-method]');
      this.message = this.querySelector('[data-message]');
      this.onChange = this.changed.bind(this);
      this.onSubmit = this.guard.bind(this);
      this.host.addEventListener('change', this.onChange, true);
      this.host.addEventListener('submit', this.onSubmit, true);
      this.observer = new MutationObserver(() => this.reconcile());
      this.observer.observe(this.host, { childList: true, subtree: true });
      if (!this.bindPicker()) {
        this.disconnectedCallback();
        return;
      }
      const selected = this.values().find(n => n.selected || n.checked);
      if (selected && selected.dataset.optionValueId !== this.wholeId) {
        this.mode = 'ground';
        this.method = selected.dataset.optionValueId;
      }
      this.hidden = false;
      this.paint();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.host?.removeEventListener('change', this.onChange, true);
      this.host?.removeEventListener('submit', this.onSubmit, true);
      clearTimeout(this.timer);
      if (this.group) { this.group.hidden = false; delete this.group.dataset.mamamNativeHidden; }
      this.host?.querySelectorAll('[data-mamam-payment-hidden]').forEach(n => {
        n.hidden = false;
        delete n.dataset.mamamPaymentHidden;
      });
    }
    values() {
      return [...this.group.querySelectorAll('input[data-option-value-id], option[data-option-value-id]')];
    }
    signature(picker = this.picker) {
      return [...picker.querySelectorAll('fieldset input:checked, select option:checked')]
        .map(n => n.dataset.optionValueId).join('|');
    }
    bindPicker() {
      const picker = this.host.querySelector('variant-selects');
      const whole = [...(picker?.querySelectorAll('[data-option-value-id]') || [])]
        .find(n => n.dataset.optionValueId === this.wholeId);
      const group = whole?.closest('fieldset, .product-form__input--dropdown');
      if (!group || !this.host.querySelector(`#${CSS.escape(this.dataset.formId)}`)) return false;
      this.picker = picker;
      this.group = group;
      this.group.hidden = true;
      this.group.dataset.mamamNativeHidden = 'true';
      const options = this.values().filter(n => n.dataset.optionValueId !== this.wholeId);
      this.select.querySelectorAll('option:not(:first-child)').forEach(n => n.remove());
      options.forEach(n => this.select.add(new Option(n.value, n.dataset.optionValueId)));
      return true;
    }
    changed(event) {
      if (this.contains(event.target)) {
        if (event.target.matches('[data-mode]')) {
          this.mode = event.target.value;
          this.method = '';
          if (this.mode === 'whole') this.choose(this.wholeId);
        } else if (event.target === this.select) {
          this.method = this.select.value;
          if (this.method) this.choose(this.method);
        }
        this.paint();
      } else if (this.picker?.contains(event.target)) {
        this.pending = true;
        this.expected = this.signature();
        this.waitingPicker = this.picker;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (this.pending) {
            this.message.textContent = this.dataset.retry;
          }
        }, 15000);
        this.paint();
      }
    }
    choose(id) {
      const target = this.values().find(n => n.dataset.optionValueId === id);
      if (!target) return;
      if (target.tagName === 'OPTION') {
        target.parentElement.value = target.value;
        target.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    reconcile() {
      const current = this.host.querySelector('variant-selects');
      if (current && current !== this.picker) {
        if (!this.bindPicker()) return;
        if (this.pending && this.picker !== this.waitingPicker && this.signature() === this.expected) {
          this.pending = false;
          clearTimeout(this.timer);
        }
        this.paint();
      } else if (this.picker) {
        this.paint();
      }
    }
    ready() {
      if (this.pending || (this.mode === 'ground' && !this.method)) return false;
      const selected = this.values().find(n => n.checked || n.selected);
      if (selected?.dataset.optionValueId !== (this.mode === 'whole' ? this.wholeId : this.method)) return false;
      try {
        const variant = JSON.parse(this.picker.querySelector('[data-selected-variant]').textContent);
        const form = this.host.querySelector(`#${CSS.escape(this.dataset.formId)}`);
        return Boolean(variant?.available && String(variant.id) === form.querySelector('[name="id"]').value);
      } catch { return false; }
    }
    paint() {
      this.querySelectorAll('[data-mode]').forEach(n => { n.checked = n.value === this.mode; });
      this.querySelector('[data-method-wrap]').hidden = this.mode !== 'ground';
      this.select.value = this.method;
      this.select.required = this.mode === 'ground';
      const text = this.pending ? this.dataset.pending :
        (this.mode === 'ground' && !this.method ? this.dataset.required : '');
      if (this.message.textContent !== text) this.message.textContent = text;
      const blocked = !this.ready();
      this.host.querySelectorAll('.shopify-payment-button').forEach(n => {
        if (blocked && !n.hidden) {
          n.hidden = true;
          n.dataset.mamamPaymentHidden = 'true';
        } else if (!blocked && n.dataset.mamamPaymentHidden) {
          n.hidden = false;
          delete n.dataset.mamamPaymentHidden;
        }
      });
    }
    guard(event) {
     if (event.target.getAttribute('id') !== this.dataset.formId || this.ready()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.message.textContent = this.pending ? this.dataset.pending :
        (this.mode === 'ground' && !this.method ? this.dataset.required : this.dataset.retry);
      if (this.mode === 'ground' && !this.method) this.select.focus();
    }
  });
}
